<template>
	<div class="s-gray-bg" style="min-height:100vh;" v-infinite-scroll="loadMore"
		infinite-scroll-disabled="isShowBottom" infinite-scroll-distance="10">

		<ul class="p-margin20 p-padding20  p-radius20 p-black s-gray-bg" style="width: auto;"
			v-if="Object.keys(stepDataListData.dataJson).length>0">
			<template >
					<li v-for="(val,key,index)  in stepDataListData.dataJson" :key="index">
						<div class="p-padding-top20 p-font1-4">
							<span>{{val.time}}</span>
						</div>
						<ul>
							<template>
								<div v-for="(v,k) in val.stepDatas" :key="k"  class="p-white-bg p-font0-8 p-margin-top20  p-padding20  p-radius20">
									<div @click="goToDetailData(v.sportsId)">
										<!-- <div class="p-space-between p-box-center-y p-padding-top10">
											<span class="p-space-between p-box-center-y  ">{{formatDateStringByMillSecond(v.sts,'MM月DD日 HH:mm:ss')}}</span>
										</div> -->
										<div class=" p-box-center-y p-font1-1" style=" padding:0.3rem 0rem 0.3rem 0rem;">
											<img :src="require('@/assets/img/nibp_list_normal.png')"
												style="width:1rem; height:1rem;margin:0.5rem 0" />
												<div class="p-margin-left10">
													<div >{{v.time}}</div>
													<div  class="p-margin-top10 p-font1-1">{{v.steps}} {{$t('sport.stepUnit')}}</div>
													<!-- <div  class="p-margin-top10 p-space-between p-box-center-x p-box-center-y p-font0-6" >
														{{getKCaloriev.avgPace}}
													</div> -->
													<div  class="p-margin-top10 p-font1-1">{{getKCalorie3(v.steps)}} {{$t('sport.Kilocalorie')}}</div>
												</div>
										</div>
									</div>

								</div>
							</template>
						</ul>
					</li>
			</template>
		</ul>
		<div v-if="stepDataListData.isShowBottom" class="p-line-height3 p-font0-8 p-color3 p-center">{{$t('common.nowLoadingMoreData')}}</div>
		<loadingContent v-else-if="stepDataListData.isLoading"></loadingContent>
		<noContent v-else-if="(!stepDataListData.isPullDown && !stepDataListData.isLoading) && stepDataListData.isNoData">
		</noContent>
		<loadedAllData v-else-if="(!stepDataListData.isPullDown && !stepDataListData.isLoading) && stepDataListData.isBottom">
		</loadedAllData>
	</div>
</template>

<script>
	import loadingContent from "../components/loading/loadingContent";
	import noContent from "../components/loading/noContent";
	import loadedAllData from "../components/loading/loadedAllData";
	import mixins from '@/utils/mixins.js'
	import {
		mapState
	} from 'vuex'
	import {
		getKCalorie,
		getKCalorie3,
		getCalorie,
		getHourBySecond,
		getMinBySecond,
		getSecondBySecond,
		getHourBySecondStr,
		getMinBySecondStr,
		getSecondBySecondStr,
		formatDateStringByMillSecond,
		getSportTypeStr,
		getSportTypeLanguageStr,
		getSportTypeImg,
	} from '@/utils/methods.js'
	export default {
		name: "bloodPressure",
		mixins: [mixins],
		components: {
			loadingContent,
			noContent,
			loadedAllData,
			monthDataSize: 0,
			isLoading: true,
			isNoData: false, // 没有数据
			isPullDown: false,
			isShowBottom: false,
			isBottomNoMore: false,
			isFrist: true,
			lastTimeFormat: '',
		},
		data() {
			return {
				sportTypeImg:'../assets/img/icon_sport_type_0.png',
				title: '',
				offset:0,
				initEts:0,
			}
		},
		methods: {
			getKCalorie3,
			getKCalorie,
			getCalorie,
			getHourBySecond,
			getMinBySecond,
			getSecondBySecond,
			formatDateStringByMillSecond,
			getHourBySecondStr,
			getMinBySecondStr,
			getSecondBySecondStr,
			getSportTypeStr,
			getSportTypeLanguageStr,
			getSportTypeImg,
			getSportTypeLanguageStrCustom(type){
				console.log("getSportTypeLanguageStrCuston  ",type);
				return getSportTypeLanguageStr(type,this)
			},
			// 获取不同类型数据
			getData(toffsetValue) {
				console.log("getData111");
				this.stepDataListData.isLoading = true;
				console.log("getData");
			
				if (0 == toffsetValue) {
					if(this.initEts==0){
						this.initEts=Date.now();
					}
					this.getStepList(0,this.initEts);
				} else {
					this.getStepList(toffsetValue,this.initEts);
				}
			},
			loadMore() {
				// //可滚动容器的高度
				// let innerHeight = this.$refs.scroll.clientHeight;
				// //屏幕尺寸高度
				// let outerHeight = document.documentElement.clientHeight;
				// //可滚动容器超出当前窗口显示范围的高度
				// let scrollTop = document.documentElement.scrollTop;
				// //scrollTop在页面为滚动时为0，开始滚动后，慢慢增加，滚动到页面底部时，出现innerHeight < (outerHeight + scrollTop)的情况，严格来讲，是接近底部。
				// console.log(innerHeight + " " + outerHeight + " " + scrollTop);
				// if (innerHeight <= outerHeight + scrollTop) {
				// 	//加载更多操作
				// console.log("loadmore");
				if(this.isFrist){
					this.isFrist=false;
					return;
				}
				if (!this.stepDataListData.isBottomNoMore) {
					console.log("loadmore");
					if(!this.isLoading){
						if (!this.stepDataListData.isShowBottom) {
							this.stepDataListData.isShowBottom = true;
							console.log("onReachBottom:------- ", this.stepDataListData.monthDataSize);
							this.getData(this.stepDataListData.monthDataSize);
						}
					}
				} else {
					console.log("loadmore  no more");
				}

				// }
			}

		},
		mounted(){
			this.isFrist=true;
			if(this.initEts!=this.$route.query.ets){
				this.initEts=this.$route.query.ets;
			}
			this.getData(0);
		},
		created() {
		},
	}
</script>

<style scoped>

</style>
